// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__36dzC","loader":"Loader_loader__EbpX6","spin":"Loader_spin__IK5Ri"};